<template>
    <div v-if="showBar" class="payment-status-bar" :style="{ backgroundColor: subscriptionStore.statusColor }"
         @click="navigateTo('invoices')">
        <v-icon size="16" color="white" class="me-2">mdi-alert-circle</v-icon>
        <span class="text-white text-body-2">{{ subscriptionStore.statusMessage }}</span>
        <template v-if="subscriptionStore.daysUntilSuspension !== null && subscriptionStore.daysUntilSuspension > 0">
            <v-chip size="x-small" color="white" variant="outlined" class="ms-2">
                {{ subscriptionStore.daysUntilSuspension }}d until suspension
            </v-chip>
        </template>
        <v-spacer/>
        <span class="text-white text-caption text-decoration-underline">View Invoices</span>
    </div>
</template>

<script setup>
import {computed} from 'vue';
import {useAuthStore} from "@/stores/authStore";
import {useSubscriptionStore} from "@/stores/subscriptionStore";
import {useNavigation} from "@/composables/globals";

const authStore = useAuthStore();
const subscriptionStore = useSubscriptionStore();
const {navigateTo} = useNavigation();

const isCompanyAdmin = computed(() => {
    const user = authStore.user;
    return user?.type === 'company' && user?.role?.toLowerCase()?.includes('admin');
});

const showBar = computed(() => isCompanyAdmin.value && subscriptionStore.needsAttention);
</script>

<style scoped>
.payment-status-bar {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 16px;
    cursor: pointer;
    z-index: 1000;
}

.payment-status-bar:hover {
    filter: brightness(1.1);
}
</style>
